const ClassesData = [
    { value: 'I', label: 'I', color: '#00B8D9', isFixed: true },
    { value: 'II', label: 'II', color: '#0052CC', isFixed: true },
    { value: 'III', label: 'III', color: '#5243AA' },
    { value: 'IV', label: 'IV', color: '#FFC400' },
    { value: 'V', label: 'V', color: '#36B37E' },
    { value: 'VI', label: 'VI', color: '#00875A' },
    { value: 'VII', label: 'VII', color: '#253858' },
    { value: 'VIII', label: 'VIII', color: '#666666' },
    { value: 'IX', label: 'IX', color: '#FF5630', isFixed: true },
    { value: 'X', label: 'X', color: '#FF8B00' }
];
export default ClassesData;